(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wd-home-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wd-reveal')) {
  customElements.define('wd-reveal', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('enabled') || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.classList.add('wd-motion-in');
          this.observer.disconnect();
        }
      }, { threshold: .12 });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
if (!customElements.get('wd-campaign')) {
  customElements.define('wd-campaign', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.abort.signal;
      const image = this.querySelector('picture img');
      const ready = () => { if (!this.mediaQuery.matches) this.classList.add('is-ready'); };
      if (image?.complete) ready();
      else image?.addEventListener('load', ready, { once: true, signal });
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.video.controls = false;
      this.button.hidden = false;
      this.video.addEventListener('play', () => {
        this.video.classList.add('is-playing');
        this.button.textContent = this.button.dataset.pause;
        this.button.setAttribute('aria-label', this.button.dataset.pause);
      }, { signal });
      this.video.addEventListener('pause', () => {
        this.button.textContent = this.button.dataset.play;
        this.button.setAttribute('aria-label', this.button.dataset.play);
      }, { signal });
      this.button.addEventListener('click', () => {
        this.userPaused = !this.video.paused;
        if (this.video.paused) this.video.play().catch(() => {});
        else this.video.pause();
      }, { signal });
      this.canAutoPlay = () => !this.mediaQuery.matches && !navigator.connection?.saveData && !this.userPaused && !document.hidden;
      this.mediaQuery.addEventListener('change', () => { if (this.mediaQuery.matches) this.video.pause(); }, { signal });
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.video.pause(); }, { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && this.canAutoPlay()) this.video.play().catch(() => {});
          else this.video.pause();
        }, { threshold: .35 });
        this.observer.observe(this);
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.abort?.abort(); this.video?.pause(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
